<template lang="html">
  <div class="row">
    <div class="col-12">
      <article class="fc-m-container">
        <h2>Account Settings</h2>
        <div class="row p-0">
          <div class="col-12 col-md-8 col-lg-6">
            <p>Make changes to your username or email below.</p>
            <form @submit="updateAccount">
              <div class="form-group">
                <label for="username">Username *</label>
                <input
                  v-model="username"
                  class="form-control"
                  type="text"
                  name="username"
                  value=""
                />
              </div>
              <div v-if="$store.state.auth.account_type != 'student'" class="form-group">
                <label for="email">Email *</label>
                <input
                  v-model="email"
                  class="form-control"
                  type="email"
                  name="email"
                  value=""
                />
              </div>
              <div v-if="$store.state.auth.account_type == 'individual'" class="form-check">
                <input type="checkbox" id="checkbox" class="form-check-input" v-model="transactionEmails">
                <label class="form-check-label" for="checkbox">Receive weekly updates on league transactions</label>
              </div>
              <p class="pt-4 small">* indicates field is required</p>
              <button type="submit" class="btn btn-primary">Update</button>
            </form>
          </div>
        </div>
      </article>
    </div>
    <div class="col-12">
      <article class="fc-m-container">
        <h2>Change Password</h2>
        <div class="row p-0">
          <div class="col-12 col-md-8 col-lg-6">
            <form @submit="changePassword">
              <div class="form-group">
                <label for="password1">Old Password *</label>
                <input
                  v-model="oldPassword"
                  class="form-control"
                  type="password"
                  name="old_password"
                  value=""
                />
              </div>
              <div class="form-group">
                <label for="password1">New Password *</label>
                <input
                  v-model="newPassword1"
                  class="form-control"
                  type="password"
                  name="new_password1"
                  value=""
                />
              </div>
              <div class="form-group">
                <label for="password2">Confirm New Password *</label>
                <input
                  v-model="newPassword2"
                  class="form-control"
                  type="password"
                  name="new_password2"
                  value=""
                />
              </div>
              <p class="small">* indicates field is required</p>
              <button type="submit" class="btn btn-primary">Submit</button>
            </form>
          </div>
        </div>
      </article>
    </div>
    <div v-if="$store.state.auth.account_type == 'educator' && account" class="col-12">
	 <article id="referral_code" class="fc-m-container">
	   <h2>Referral Code</h2>
	   <div class="row p-0">
			<div class="col-12 col-md-8 col-lg-6">
				<p>Get up to <strong>$100 off</strong> your next year of Fantasy Congress
					by sharing your referral code.
				</p>
			<div> Your referral code is:
		  		   <p class="alert alert-info">
		  			   <strong>{{account.misc.code}}</strong>
		  		   </p>
				   <p v-if="account.misc.referral_count">
					   Available referrals: {{10 - account.misc.referral_count}}
				   </p>
				   <p v-else>
					   Available referrals: 10
				   </p>
		  	   </div>
			   	<p>Get $10 off next year's subscription for each educator who signs up using your code.
					Each new user you refer will get $50 off their first year of Fantasy Congress.
					Referral codes can be used a maximum of 10 times per billing period.
				</p>
			</div>
		</div>

	</article>

	</div>
    <div v-if="$store.state.auth.account_type != 'student'" class="col-12">
      <article class="fc-m-container">
        <h2>Update Billing</h2>
        <div class="row p-0">
          <div class="col-12 col-md-8 col-lg-6">
            <div v-if="$store.state.auth.is_customer == true">
              <p> 
                Visit our billing portal to update your payment information.
              </p>
              <a :href="billingUrl" target="_blank" class="btn btn-primary">Billing Portal</a>
              
            </div>
            <div v-else>
              <p v-if="$store.state.auth.account_type == 'educator'">
                Upgrade to a paid membership to create your very own Fantasy Congress league!
              </p>
              <p v-else>
                Upgrade to a paid membership to join public leagues, invite friends, and create your very own Fantasy Congress league!
              </p>
              <a :href="billingUrl" target="_blank" class="btn btn-primary">Continue</a>
            </div>


          </div>
        </div>
      </article>
    </div>
    <div v-if="$store.state.auth.account_type != 'student'" class="col-12">
      <article class="alert alert-danger">
        <h2>Delete Account</h2>
        <p class="">
          All data associated with this account (including leagues and teams you created) will be removed.
          Your subscription will be canceled. You can not
          undo this action.
        </p>
        <button
          @click="deleteAccount"
          class="btn btn-danger"
          type="button"
          name="button"
        >
          Delete account
        </button>
      </article>
    </div>
  </div>
</template>

<script>
import { getCookie } from "@/utils/cookies.js";
import { handleFormErrors, handleErrors } from "@/utils/errors.js";
import Loader from "@/views/components/Loader";

export default {
  name: "Account",
  components: {
    loader: Loader
  },
  data: function() {
    return {
      account: null,
      username: "",
      email: "",
      oldPassword: "",
      newPassword1: "",
      newPassword2: "",
      plan: "monthly",
      billingUpdate: false,
      transactionEmails: true,
      billingUrl: null,
    };
  },
  created: function() {
    this.getUser();
  },
  methods: {
    changePassword: function(e) {
      e.preventDefault();

      let app = this;
      const csrftoken = getCookie("csrftoken");

      let form = new URLSearchParams({
        old_password: app.oldPassword,
        new_password1: app.newPassword1,
        new_password2: app.newPassword2
      });

      fetch(
        process.env.VUE_APP_PLATFORM +
          "/accounts/" +
          app.$store.state.auth.user_id +
          "/change-password/",
        {
          credentials: "include",
          method: "POST",
          mode: "cors",
          body: form,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-CSRFToken": csrftoken
          }
        }
      ).then(function(response) {
        if (response.status == 200) {
          app.$store.commit("alert/addMessage", {
            message: `Your password has been updated.`,
            class: "success",
            persist: false
          });
          app.oldPassword = ''
          app.newPassword1 = ''
          app.newPassword2 = ''
        } else {
          let response_json = response.json();
          response_json.then(function(response) {
            handleFormErrors(response.errors);
          });
        }
      });
    },
    deleteAccount: function() {
      let app = this;
      const csrftoken = getCookie("csrftoken");

      fetch(
        process.env.VUE_APP_PLATFORM +
          "/accounts/" +
          app.$store.state.auth.user_id +
          "/",
        {
          credentials: "include",
          method: "DELETE",
          mode: "cors",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-CSRFToken": csrftoken
          }
        }
      ).then(function(response) {
        if (response.status == 204) {
          fetch(process.env.VUE_APP_PLATFORM + "/logout/", {
            credentials: "include",
            mode: "cors"
          }).then(function(response) {
            app.$store.commit("auth/logout");
            app.$router.push("/login");
            app.$store.commit("alert/addMessage", {
              message: `Your account has been deleted.`,
              class: "success",
              persist: false
            });
          });
        } else {
          let response_json = response.json();
          response_json.then(function(response) {
            handleErrors(response.errors);
          });
        }
      });
    },
    getUser: function() {
      let app = this;
      fetch(
        process.env.VUE_APP_PLATFORM +
          "/accounts/" +
          this.$store.state.auth.user_id +
          "/",
        {
          credentials: "include",
          mode: "cors"
        }
      )
        .then(function(response) {
          return response.json();
        })
        .then(function(response) {
          app.account = response
          app.username = response.username;
          app.email = response.email;
          app.transactionEmails = response.email_settings.transactions
          app.billingUrl = response.billing_url;
        });
    },
    updateAccount: function(e) {
      e.preventDefault();

      let app = this;
      const csrftoken = getCookie("csrftoken");

      let form = new URLSearchParams({
        username: app.username,
        email: app.email,
        transactions: app.transactionEmails
      });

      fetch(
        process.env.VUE_APP_PLATFORM +
          "/accounts/" +
          app.$store.state.auth.user_id +
          "/",
        {
          credentials: "include",
          method: "PATCH",
          mode: "cors",
          body: form,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-CSRFToken": csrftoken
          }
        }
      ).then(function(response) {
        if (response.status == 200) {
          app.getUser();
          app.$store.commit("auth/updateUsername", {username: app.username})
          app.$store.commit("alert/addMessage", {
            message: `Your account was updated.`,
            class: "success",
            persist: false
          });
        } else {
          let response_json = response.json();
          response_json.then(function(response) {
            handleFormErrors(response);
          });
        }
      });
    },
    handleErrors: function(errors) {
      let app = this;
      let errorFields = Object.keys(errors);
      for (let i = 0; i < errorFields.length; i++) {
        for (let x = 0; x < errors[errorFields[i]].length; x++) {
          let field = errorFields[i];
          if (field.search("password") != -1) {
            field = field == "password2" ? "confirm password" : "password";
          }
          app.$store.commit("alert/addMessage", {
            message: `${field}: ${errors[errorFields[i]][x]}`,
            class: "danger",
            persist: false
          });
        }
      }
    },
  }
};
</script>
